<template>
    <BaseElement v-model="value" :edit="edit" :create="create" :element="'input'">
        <template #main="{text}">
            <template v-if="edit">
                <select
                    :id="value.id"
                    :class="classes"
                    :style="value.style"
                    :disabled="value.disabled"
                    :type="value.type"
                    v-model="value.value"
                    :defaultValue="value.value"
                >
                    <option :value="null" disabled selected v-if="value.placeholder">{{ value.placeholder }}</option>
                    <option v-for="option in options" :value="option">{{ option }}</option>
                </select>
                <span v-if="value.units" class="ms-1">{{ value.units }}</span>
            </template>
            <template v-else>
                <input
                    :id="value.id"
                    :class="value.class"
                    :style="value.style"
                    :type="value.type"
                    :disabled="true"
                    v-model="value.value"
                    :defaultValue="value.value"
                    :placeholder="value.placeholder"
                >
            </template>
        </template>
    </BaseElement>
</template>

<script>
import BaseElement from '@/components/calculations/BaseElement.vue';

export default {
    components: {
        BaseElement
    },
    props: {
        modelValue: {},
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        create: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        show: function () {
            return this.value && !this.value.hide;
        },
        options: function () {
            if (!this.value || !this.value.options) {
                return []
            }
            var data = []
            var lines = this.value.options.split("\n");
            for (var i = 0; i < lines.length; i++){
                data.push(lines[i]);
            }
            return data;
        },
        classes: function () {
            var classes_all = this.value.class;
            if (this.value.placeholder && this.value.value == null) {
                classes_all += " placeholder_select"
            }
            return classes_all
        }
    }
}
</script>

<style lang="scss">
</style>